// Collect UTM + tracking params from URL and return a `tracking` object for form payloads.
export function collectTracking({ formType, leadMagnet, enquiryType } = {}) {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get("utm_source") || null,
    utm_medium: params.get("utm_medium") || null,
    utm_campaign: params.get("utm_campaign") || null,
    utm_content: params.get("utm_content") || null,
    utm_term: params.get("utm_term") || null,
    source_page: window.location.pathname || null,
    form_type: formType || null,
    lead_magnet: leadMagnet || null,
    enquiry_type: enquiryType || null,
  };
}
